import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-manager.png'
import _imports_1 from '@/assets/images/favorite-chart.png'
import _imports_2 from '@/assets/images/status-up.png'
import _imports_3 from '@/assets/images/setting.png'


const _hoisted_1 = {
  class: "custom-navi",
  style: {"padding-bottom":"70px"}
}

import { defineComponent, reactive, toRefs, watch, ref, onMounted, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import {  
  UserStatusMap,
  UserRoleOperator,
  UserRoleDirectorManager,
  UserRoleDirector,
  UserRoleBlogger,
  UserRoleAuditor,
} from '@/utils/macro'



export default /*@__PURE__*/_defineComponent({
  __name: 'Navi',
  setup(__props) {

const isProd = ref(window.location.hostname=='koc.marsvis.com')

const store = useStore()

const user_role = computed(() => store.state.user.role)

const router = useRouter()
const route = useRoute()

console.log('route.meta.key', route.meta.key);

const openKeys = ref([])
const selectedKeys = ref([])

onMounted(() => {
  selectedKeys.value = [route.path]
  console.log('route', route);
  
  openKeys.value = [route.meta.key]
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_menu, {
      openKeys: openKeys.value,
      "onUpdate:openKeys": _cache[0] || (_cache[0] = ($event: any) => ((openKeys).value = $event)),
      selectedKeys: selectedKeys.value,
      "onUpdate:selectedKeys": _cache[1] || (_cache[1] = ($event: any) => ((selectedKeys).value = $event)),
      mode: "inline"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_sub_menu, { key: "basic" }, {
          icon: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("img", {
              class: "navi-icon",
              src: _imports_0,
              alt: ""
            }, null, -1)
          ]))]),
          title: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("用户管理", -1)
          ]))]),
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { key: "/keywords/profile" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/profile'} }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createTextVNode(" 个人设置 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/users" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/users'} }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" 博主管理 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            ([ _unref(UserRoleDirectorManager) ].indexOf(user_role.value) > -1)
              ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "/keywords/directors" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: { path: '/keywords/directors'} }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode(" 团长管理 ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_a_sub_menu, { key: "keyword" }, {
          icon: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createElementVNode("img", {
              class: "navi-icon",
              src: _imports_1,
              alt: ""
            }, null, -1)
          ]))]),
          title: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode("推广中心", -1)
          ]))]),
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { key: "/keywords/cpeAccounts" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/cpeAccounts'} }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode(" 账号管理 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/cpeMaterials" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/cpeMaterials'} }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode(" 素材管理 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/cpeWorks" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/cpeWorks'} }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode(" 作品管理 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/apply" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/apply'} }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode(" 关键词管理 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_sub_menu, { key: "stats" }, {
          icon: _withCtx(() => [...(_cache[13] || (_cache[13] = [
            _createElementVNode("img", {
              class: "navi-icon",
              src: _imports_2,
              alt: ""
            }, null, -1)
          ]))]),
          title: _withCtx(() => [...(_cache[14] || (_cache[14] = [
            _createTextVNode("数据中心", -1)
          ]))]),
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { key: "/keywords/stats_keyword" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/stats_keyword'} }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode(" 关键词每日数据 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/stats_keyword_sum" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/stats_keyword_sum'} }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode(" 关键词累计数据 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/stats_data_blogger" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/stats_data_blogger'} }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode(" 博主累计数据 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/stats_newer_platform_sum" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/stats_newer_platform_sum'} }, {
                  default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                    _createTextVNode(" 平台累计数据 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            ([ _unref(UserRoleDirectorManager) ].indexOf(user_role.value) > -1)
              ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "/keywords/stats_data_director_daily" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: { path: '/keywords/stats_data_director_daily'} }, {
                      default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                        _createTextVNode(" 团长每日统计 ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ([ _unref(UserRoleDirectorManager) ].indexOf(user_role.value) > -1)
              ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "/keywords/stats_data_director" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: { path: '/keywords/stats_data_director'} }, {
                      default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                        _createTextVNode(" 团长数据统计 ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_menu_item, { key: "/keywords/settlement" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/settlement'} }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                    _createTextVNode(" 结算数据 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/activity" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/activity'} }, {
                  default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                    _createTextVNode(" 活动数据报表 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "/keywords/cpeWorkDatas" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/cpeWorkDatas'} }, {
                  default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                    _createTextVNode(" CPE作品数据 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        ([ _unref(UserRoleDirectorManager) ].indexOf(user_role.value) > -1)
          ? (_openBlock(), _createBlock(_component_a_sub_menu, { key: "payment" }, {
              icon: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createElementVNode("img", {
                  class: "navi-icon",
                  src: _imports_3,
                  alt: ""
                }, null, -1)
              ]))]),
              title: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                _createTextVNode("付款管理", -1)
              ]))]),
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item, { key: "/keywords/payment_signs" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_link, { to: { path: '/keywords/payment_signs'} }, {
                      default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                        _createTextVNode(" 用户签约状态 ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_a_sub_menu, { key: "setting" }, {
          icon: _withCtx(() => [...(_cache[27] || (_cache[27] = [
            _createElementVNode("img", {
              class: "navi-icon",
              src: _imports_3,
              alt: ""
            }, null, -1)
          ]))]),
          title: _withCtx(() => [...(_cache[28] || (_cache[28] = [
            _createTextVNode("设置", -1)
          ]))]),
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { key: "/keywords/upload" }, {
              default: _withCtx(() => [
                _createVNode(_component_router_link, { to: { path: '/keywords/upload'} }, {
                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                    _createTextVNode(" 上传管理 ", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["openKeys", "selectedKeys"])
  ]))
}
}

})